import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { DisAssembleTransactionPopup } from './DisAssembleTransactionTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';

export default class DisAssembleTransaction extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        //this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            isSelectItemPopUp: false,
            transactionObject: {
                idDisAssemble: 0,
                updateStatus: 0,
                dAssNo: '',
                date: new Date().toISOString(),
                idDAssFrom: 2,
                dAssList: [
                    // {
                    //     value: 1,
                    //     label: "FROM SALES RETURN"
                    // },
                    {
                        value: 2,
                        label: "FROM STOCK"
                    },
                ],
                idChallanNo: 0,
                challanNoList: [],
                idProduct: 0,
                itemIdLabel: "",
                idItem: 0,
                productList: [],
                quantity: '',
                dQuantity: '',
                refNo: '',
                refDate: '',
                idPlant: '',
                plantList: [],
                assembly: false,
                assemblyDate: '',
                itemRowData: [],
                e_Date: '',
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                product: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemType",
                    headerName: "Item Type",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "productName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            this.getAllDropdownAndCountsForOtherForms();
            this.getMasterProductSelectForProductionStock();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransaction_DisAssembleSelectbyId(event.data.idDisAssemble);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.transactionObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.transactionObject;
        if (name === "assembly") {
            details.assembly = !details.assembly
        } else {
            details[name] = value;
        }
        this.setState({ transactionObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idDisAssemble);
    };

    handleChangeForDropdown = (event, name) => {
        let details = this.state.transactionObject;
        let value = event.value;
        // if (name === 'rateOn' || name === 'itemType') {
        //     details[name] = event.label;
        // } else {
        details[name] = value;
        //}
        this.setState({ transactionObject: details }, () => {
            if (name === 'idProduct') {
                this.getMasterProductSelectForProductionStock2()
            }
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownAndCountsForOtherForms();
                this.getMasterProductSelectForProductionStock();
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "DisAssemble Transaction",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idDisAssemble", "returnNo", "billNo", "billDate"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "DisAssemble Transaction",
                            colName: colName
                        }, () => {
                            // this.procSelectAllRecord2GridviewSP(id, "Material IN");
                            this.setPermissions(permissions);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.02,
            "disAssembleFrom": window.innerWidth * 0.04,
            "disAssembleNo": window.innerWidth * 0.06,
            "date": window.innerWidth * 0.04,
            "itemName": window.innerWidth * 0.28,
            "disAssembleQty": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id,) => {
        let request = {
            id: id,
            formname: 'DisAssemble Transaction',
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    getAllDropdownAndCountsForOtherForms = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getAllDropdownAndCountsForOtherForms(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.transactionObject;
                let dAssNo = allData.filter(item => item.source === 'DisAssembleCount')?.[0].value;
                let maxIdPaymentMake = dAssNo > 0 ? dAssNo : 0;
                let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                data.dAssNo = receiptNo;
                data.date = moment(new Date()).format('YYYY-MM-DD')
                this.setState({
                    materialObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getTransactionSalesReturnForDisAssemble = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getTransactionSalesReturnForDisAssemble(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.transactionObject;
                if (allData.length > 0) {
                    allData = allData.map((x) => ({
                        value: x.idMaterialOut,
                        label: x.challanNo + ', ' + x.vendor,
                    }));
                }
                //data.dAssNo = allData.filter(item => item.source === 'DisAssembleCount')?.[0].value + 1;
                //data.supplierList = allData.filter(item => item.source === 'Master_PartyAccount');
                this.setState({
                    transactionObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMasterProductSelectForProductionStock = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getMasterProductSelectForProductionStock(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.transactionObject;
                data.productList = [];
                if (allData.length > 0) {
                    data.productList = allData.filter((x) => (x.itemType === 'SEMI FINISHED' || x.itemType === 'FINISHED GOODS'));
                }
                this.setState({
                    transactionObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMasterProductSelectForProductionStock2 = () => {
        if (this.state.transactionObject.idDAssFrom === 2 && this.state.transactionObject.idProduct > 0) {
            let request = [this.state.transactionObject.idProduct, this.state.idCompany, 0];
            this.otherFormsServices.getMasterProductSelectForProductionStock2(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent[0];
                    let data = this.state.transactionObject;
                    data.quantity = 0;
                    data.dQuantity = 0;
                    data.idItem = 0;
                    if (allData) {
                        data.quantity = allData.currentStock;
                        data.dQuantity = allData.currentStock;
                        data.idItem = allData.idItem;
                    }
                    this.setState({
                        transactionObject: data
                    });
                }
            });
        }
    }

    showBOMRecords = () => {
        if (this.state.transactionObject.idProduct > 0) {
            if (this.state.transactionObject.dQuantity <= this.state.transactionObject.quantity) {
                let request = [this.state.transactionObject.idItem];
                this.otherFormsServices.getMasterItemSelectbyIdForDisAssemble(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let allData = response.responseItem.responseContent[0];
                        let data = this.state.transactionObject;
                        var qty = data.dQuantity;
                        let req = [allData.idItem, this.state.idCompany];
                        this.otherFormsServices.getMasterProductReceipeSelectForDisAssembleItem(req).then((res) => {
                            if (res.statusCode == 200 && res.responseItem !== null) {
                                let allData = res.responseItem.responseContent;
                                //let data = this.state.transactionObject;
                                data.itemRowData = [];
                                if (allData.length > 0) {
                                    //data.quantity = allData.currentStock;
                                    allData = allData.map((x, key) => ({
                                        idItem: x.idItem,
                                        drawingNo: x.drawingNo,
                                        itemType: x.itemType,
                                        itemName: x.itemName,
                                        quantity: x.requiredQuantity,
                                        disAssembleQty: qty * x.requiredQuantity,

                                        isParent: 1,
                                        isChild: 0,
                                        parentId: 0,
                                        rejection: x.rejection,
                                        storeTransfer: x.storeTransfer,
                                        rework: x.reWork,
                                        reworkComplete: x.reWorkComplete,
                                        completeDate: moment(x.completeDate).format('YYYY-MM-DD'),
                                        rejectedPartChange: x.rejectedPartChange,
                                        changeDate: moment(allData.changeDate).format('YYYY-MM-DD'),
                                        key: key + 1,

                                    }));

                                    // allData.map((x) => {
                                    //     x.storeTransfer = true
                                    // }
                                    // );

                                    data.itemRowData = [...allData];
                                }
                                this.setState({
                                    transactionObject: data
                                });

                            }
                        });
                        this.setState({
                            transactionObject: data
                        });
                    }
                });
            } else {
                this.SwalServices.Alert("D-Qty should be less then stock qty")
            }
        }
    }


    getTransaction_DisAssembleSelectbyId = (id) => {
        if (id > 0) {
            this.otherFormsServices.getTransaction_DisAssembleSelectbyId(id).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent[0][0];
                    let getList = response.responseItem.responseContent[1];
                    let itemList = [];
                    let object = this.state.transactionObject
                    object.idDisAssemble = allData.idDisAssemble;
                    object.updateStatus = 1;
                    object.dAssNo = allData.disAssembleNo;
                    object.date = allData.date ? moment(allData.date).format('YYYY-MM-DD') : "";
                    object.idDAssFrom = object.dAssList.find(x => x.label === allData.disAssembleFrom)?.value;
                    //object.dAssList = allData. ;
                    object.idChallanNo = allData.idDeliveryChallan;
                    //object.challanNoList = allData. ;
                    object.idProduct = allData.idProduct;
                    object.itemIdLabel = object.productList.find(x => x.idProduct === allData.idProduct).productName
                    //object.productList = allData. ;
                    object.quantity = allData.challanQty;
                    object.dQuantity = allData.disAssembleQty;
                    object.refNo = allData.refNo;
                    object.refDate = allData.refDate ? moment(allData.refDate).format('YYYY-MM-DD') : "";
                    object.idPlant = allData.idPlant ? allData.idPlant : 0;
                    //object.plantList = allData.;
                    object.assembly = allData.isComplete;
                    object.assemblyDate = allData.completeDate ? moment(allData.completeDate).format('YYYY-MM-DD') : "";
                    object.e_Date = allData.e_Date;
                    object.itemRowData = [];
                    if (getList.length > 0) {
                        object.idItem = getList[0]?.idItem;
                        getList.map((x, key) => {
                            let obj = {
                                idItem: x.idItem,
                                drawingNo: x.drawingNo,
                                itemType: x.itemType,
                                itemName: x.itemName,
                                quantity: x.bomQuantity,
                                disAssembleQty: x.disAssembleQty,

                                isParent: 1,
                                isChild: 0,
                                parentId: 0,
                                rejection: false,
                                storeTransfer: true,
                                rework: false,
                                reworkComplete: false,
                                completeDate: "",
                                rejectedPartChange: false,
                                changeDate: x.changeDate ? moment(x.changeDate).format('YYYY-MM-DD') : "",
                                key: key + 1,
                            }
                            itemList.push(obj);
                        })
                    }
                    object.itemRowData = itemList;
                    this.setState({
                        transactionObject: object, isModalOpen: true
                    }, () => {

                        this.getMasterProductSelectForProductionStock();
                    });
                } else {
                    //this.usp_Master_EmployeeSelect()
                }
            });
        }
    }


    submit = () => {
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        // if (this.state.itemRowData.length === 0) {
        //     this.SwalServices.Alert("Please add product items details");
        // } else {
        let obj = this.state.transactionObject;
        let request = {
            idDisAssemble: obj.idDisAssemble,
            updateStatus: obj.updateStatus,
            disAssembleNo: obj.dAssNo,
            date: obj.date,
            disAssembleFrom: obj.dAssList.find(x => x.value === obj.idDAssFrom)?.label,
            idDeliveryChallan: obj.idChallanNo,
            idProduct: obj.idProduct,
            challanQty: obj.quantity,
            disAssembleQty: obj.dQuantity,
            remarks: "",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
            e_Date: obj.e_Date ? obj.e_Date : new Date().toISOString(),
            e_IDUser: obj.updateStatus === 1 ? this.state.idUser : null,
            isUpdated: obj.updateStatus === 1 ? true : false,
            updatedDate: obj.updateStatus === 1 ? new Date().toISOString() : null,
            u_IDUser: obj.updateStatus === 1 ? this.state.idUser : null,
            isDeleted: false,
            deletedDate: null,
            d_IDUser: null,
            idSalesReturnItems: obj.idProduct,
            refNo: obj.refNo,
            refDate: obj.refDate,
            isComplete: obj.assembly,
            completeDate: obj.assemblyDate,
            idFinancialYear: 0,
        };
        request.itemList = [];
        obj.itemRowData.map((x) => {
            let obj = {
                //idDisAssemble: null,
                type: x.type ? x.type : "",
                idItem: x.idItem,
                bomQuantity: x.quantity,
                disAssembleQty: x.disAssembleQty,
                isItem: x.isItem,
                remarks: "",
                rejection: x.rejection,
                storeTransfer: x.storeTransfer,
                reWorkComplete: x.reworkComplete,  // required (not nullable)
                completeDate: x.completeDate,
                rejectedPartChange: x.rejectedPartChange,
                changeDate: x.changeDate,
                //reWork: null,
                reWork: x.rework,

                // idDisAssemble: x. ,
                // type: x. ,
                // idItem: x. ,
                // bomQuantity: x. ,
                // disAssembleQty: x. ,
                // isItem: x. ,
                // remarks: x. ,
                // rejection: x. ,
                // storeTransfer: x. ,
                // reWorkComplete: x. ,
                // completeDate: x. ,
                // rejectedPartChange: x. ,
                // changeDate: x. ,
                // reWork: x. ,

                /// old code remove 

                // idPurchaseOrderItems: details.idPurchaseOrderItems,
                // idPurchaseOrder: data.idPurchaseOrder,
                // drawingNo: details.drawingNo,
                // itemType: productObject.materialTypeList.find(x => x.value === details.idMaterialType)?.label,
                // idItem: details.idItem,
                // quantity: details.quantity,
                // invoiceRate: null,
                // rate: details.rate,
                // actualRate: details.actualRate,
                // isVariation: details.rate > details.actualRate ? true : false,
                // poAmount: null,
                // amount: details.amount,
                // discount: details.discount,
                // extraCharges: details.chargesAmt,
                // poTaxableAmt: null,//details.tot,
                // taxableAmt: details.total,
                // sgst: details.sgst,
                // sgstAmt: details.sgstAmount,
                // cgst: details.cgst,
                // cgstAmt: details.cgstAmount,
                // igst: details.igst,
                // igstAmt: details.igstAmount,
                // netTotal: details.netTotal,
                // idTaxGroup: details.idTaxGroup,
                // idPurchaseInquiry: 0, //details.idPurchaseInquiry,
                // idPurchaseInquiryItems: 0, // details.idPurchaseInquiryItems,
                // idPoItem: 0, // required, not nullable
                // itemRemarks: details.remarks,
                // idMaterialPlanning: 0,
                // idMaterialPlanningDetails: 0,
                // startDate: details.startDate,
                // endDate: details.endDate
            }
            request.itemList.push(obj);
        });
        this.otherFormsServices.submitDisAssembleInsertUpdate(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data !== null) {
                    if (this.state.transactionObject.updateStatus === 1) {
                        this.SwalServices.Success("Updated sucessfully.");
                    } else {
                        this.SwalServices.Success("Save sucessfully.");
                    }
                    if (this.state.urlId) {
                        this.setState({ route: '/ledger-report' });
                    } else {
                        this.setState({
                            isModalOpen: false,
                            //receiptDetails: reset
                        }, () => {
                            this.resetFields();
                            this.procSelectAllRecordsSP();
                        });
                    }
                }
            }
        });
        //}
        //}
    }

    resetFields = () => {
        let reset = this.state.transactionObject;
        reset.idDisAssemble = 0;
        reset.updateStatus = 0;
        reset.dAssNo = '';
        reset.date = new Date().toISOString();
        reset.idDAssFrom = 2;
        reset.idChallanNo = 0;
        reset.challanNoList = [];
        reset.idProduct = 0;
        reset.idItem = 0;
        reset.quantity = '';
        reset.dQuantity = '';
        reset.refNo = '';
        reset.refDate = '';
        reset.idPlant = '';
        reset.plantList = [];
        reset.assembly = false;
        reset.assemblyDate = '';
        reset.itemRowData = [];
        reset.e_Date = '';
        this.setState({ transactionObject: reset })
    }

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.transactionObject;
        data.idProduct = event.data.idProduct;
        data.itemIdLabel = event.data.productName;
        this.setState({ transactionObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.getMasterProductSelectForProductionStock2()
        });
    };

    render() {
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <DisAssembleTransactionPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            transactionObject={this.state.transactionObject}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            showBOMRecords={this.showBOMRecords.bind(this)}
                            handleOnClick={this.handleOnClick.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">DisAssemble transaction</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.transactionObject.productList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
            </div>
        )
    }
}
